import { ReturnsModule } from '@/shared';

export default ReturnsModule;
